import axios from 'axios';
import { apiUrl } from '@/env';
import {IUserProfile, IUserProfileUpdate, IUserProfileCreate, ITopup, ITransaction, IBuyPackage} from './interfaces';

function authHeaders(token: string) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export const api = {
  async getVersion() {
    return axios.get<{version: string}>(`${apiUrl}/api/v1/version/`);
  },
  async logInGetToken(username: string, password: string) {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    return axios.post(`${apiUrl}/api/v1/login/access-token`, params);
  },
  async getMe(token: string) {
    return axios.get<IUserProfile>(`${apiUrl}/api/v1/users/me`, authHeaders(token));
  },
  async updateMe(token: string, data: IUserProfileUpdate) {
    return axios.put<IUserProfile>(`${apiUrl}/api/v1/users/me`, data, authHeaders(token));
  },
  async getUsers(token: string) {
    return axios.get<IUserProfile[]>(`${apiUrl}/api/v1/users/`, authHeaders(token));
  },
  async updateUser(token: string, userId: number, data: IUserProfileUpdate) {
    return axios.put(`${apiUrl}/api/v1/users/${userId}`, data, authHeaders(token));
  },
  async createUser(token: string, data: IUserProfileCreate) {
    return axios.post(`${apiUrl}/api/v1/users/`, data, authHeaders(token));
  },
  async passwordRecovery(email: string) {
    return axios.post(`${apiUrl}/api/v1/password-recovery/${email}`);
  },
  async resetPassword(password: string, token: string) {
    return axios.post(`${apiUrl}/api/v1/reset-password/`, {
      new_password: password,
      token,
    });
  },
  async topupAis(token: string, data: ITopup) {
    return await axios.post(`${apiUrl}/api/v1/topups/ais`, data, authHeaders(token));
  },
  async topupDtac(token: string, data: ITopup) {
    return await axios.post(`${apiUrl}/api/v1/topups/dtac`, data, authHeaders(token));
  },
  async topupTrue(token: string, data: ITopup) {
    return await axios.post(`${apiUrl}/api/v1/topups/true`, data, authHeaders(token));
  },
  async getTopups(token: string) {
    // TODO: skip and limit are still hard-coded
    return await axios.get<ITransaction[]>(`${apiUrl}/api/v1/topups/?skip=0&limit=10000`, authHeaders(token));
  },
  async verifyNumber(token: string, phone: string) {
    return await axios.get(`${apiUrl}/api/v1/topups/verify-number/${phone}`, authHeaders(token));
  },
  async getMobilePackages(token: string) {
    return await axios.get(`${apiUrl}/api/v1/topups/get-mobile-packages`, authHeaders(token));
  },
  async buyPackage(token: string, data: IBuyPackage) {
    return await axios.post(`${apiUrl}/api/v1/topups/buy-package`, data, authHeaders(token));
  },
  async addCredit(token: string, userId: number, amount: number) {
    return await axios.put(`${apiUrl}/api/v1/admin/add_credit/${userId}`, { amount }, authHeaders(token));
  },
};
